<template>
  <div class="navigatorAUToolsUsersDashboard">
  <NavbarComponent :loadingStatus="loading">Navigator AU Tools Users</NavbarComponent>
  <section class="navgiatorautoolssection">
  <div v-if="!loading" class="container is-fluid">
    {{message}}
    <br>
  <b-button
                            label="Add New"
                            type="is-primary"
							@click="addNewModal=true"/>
<br>
  <div class="datatable">
  
  
  <div v-if="tableData">    
<b-table :data="tableData" :options="options">

        <b-table-column field="id" label="Name" width="50px"  v-slot="props">
            {{ props.row.id}}
        </b-table-column>
               <b-table-column field="GID" label="GID"  v-slot="props">
            {{ props.row.GID }}
        </b-table-column>
        <b-table-column field="first_name" label="First Name"  v-slot="props">
            {{ props.row.first_name }}
        </b-table-column>
                <b-table-column field="last_name" label="Last Name"  v-slot="props">
            {{ props.row.last_name}}
        </b-table-column>
                <b-table-column field="navigator_machine_account_name" label="Navigator Machine Account Name"  v-slot="props">
            {{ props.row.navigator_machine_account_name }}
        </b-table-column>
                      <b-table-column field="is_superuser" label="Is Superuser"  v-slot="props">
            {{ props.row.is_superuser}}
        </b-table-column>
              <b-table-column field="is_readonly" label="Is Readonly"  v-slot="props">
            {{ props.row.is_readonly}}
        </b-table-column>
                           <b-table-column field="delete" label="Delete"  v-slot="props">
            <b-button
                            label="Delete"
                            type="is-dark"
							@click="deleteUserButton(props.row.id, props.row.GID, props.row.first_name, props.row.last_name)"/>
        </b-table-column>
 
  </b-table>
</div>
  
  </div>
  
  
  


                      
 </div>
 </section>
 
    
  <b-modal v-model="addNewModal" :active.sync="addNewModal"  :autofocus="true">
                <div class="modal-card">

                    <section class="modal-card-body">
                        <b-field label="GID"  message="Access to Nav AU Tools uses GID from MyID Credentials.">
                            <b-input type="text"
                            id="password_input"
                            v-model="new_GID"
                            >
                            </b-input>
                            </b-field>
                                         <b-field label="First Name">
                            <b-input type="text"
                            v-model="new_first_name"
                             >
                            </b-input>
                            </b-field>
                                  </b-field>
                                         <b-field label="Last Name">
                            <b-input type="text"
                            v-model="new_last_name"
                             >
                            </b-input>
                            </b-field>
                                </b-field>
                               <b-field label="Navigator Machine Account Name"  message="Will use corresponding machine account with matching name from Nav AU Tools database.">
                            <b-input type="text"
                            v-model="new_navigator_machine_account_name"
                             >
                            </b-input>
                            </b-field>
                                   </b-field>
                                         <b-field label="Is Superuser" message="Only superusers can view and use superuser only dashboards.">
                             <b-checkbox v-model="new_is_superuser">
            </b-checkbox>
                            </b-input>
                             </b-field>
                                         <b-field label="Is Readonly" message="Readonly users only have access to readonly dashboards.">
                             <b-checkbox v-model="new_is_readonly">
            </b-checkbox>
                            </b-input>
                            </b-field>
                            
                 
                        </section>
                    
                        <b-button
                            label="Add"
                            type="is-warning"
							@click="addUser"/>
                       <b-button
                            label="Close"
                            type="is-primary"
							@click="addNewModal=false"/>
               
               
         
                 
                </div>

        </b-modal>


        
  <b-modal v-model="deleteModalActive" :active.sync="deleteModalActive"  :autofocus="true">
                <div class="modal-card">

                    <section class="modal-card-body">
                      Deleting {{this.deleteUserGID}} {{this.deleteUserFirstName}} {{this.deleteUserLastName}}
                      <br>
                      Confirm you want to delete user?
                        </section>
                    
                        <b-button
                            label="Yes, Delete."
                            type="is-warning"
							@click="deleteUser()"/>
                

                  <b-button
                            label="No, Cancel."
                            type="is-primary"
							@click="deleteModalActive=false"/>
                </div>

        </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import NavbarComponent from '@/components/NavbarComponent.vue'



export default {
  name: 'NavigatorScriptDownloader',
  props: {
  },
  components: {NavbarComponent},
  data() {return {
    loading: false,
    message: '',
    deleteUserId: '',
    deleteUserFirstName:'',
    deleteUserLastName:'',
    deleteUserGId:'',
    addNewModal: false,
    deleteModalActive: false,

    new_GID:'',
    new_first_name:'',
    new_last_name:'',
    new_client_id:'',
    new_navigator_machine_account_name:'',
    new_is_superuser:false,
    new_is_readonly:true,
    scripts: [],
    scriptDownloadIdList: [],
    tableData:[],
    columns: ['id', 'user_name', 'client_id'],
        options: {  
      sortIcon: { //set sort icons
        base : 'fa',
        is: 'fa-sort',
        up:  'fa-sort-down',
        down:   'fa-sort-up'
      }
},
    }
  },
  methods:{
    async getUsers(){


        this.loading=true;
            //Navigator devices API url
            const url = this.$store.getters.apiurl + "users"

            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.tableData = response.data.data
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
    },

    deleteUserButton(id,GID,first_name,last_name)
    {
      console.log("deleting")
    this.deleteUserId = id
    this.deleteUserGID = GID
    this.deleteUserFirstName= first_name
    this.deleteUserLastName= last_name
    this.deleteModalActive=true
    },

    async deleteUser(){

              this.loading=true;
            //Navigator devices API url
            const url = this.$store.getters.apiurl + "user/" + this.deleteUserId

            this.$axios({ method: 'delete',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded','Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                 this.getUsers();
                 this.loading=false;
				 this.message = "";
                 this.deleteModalActive=false;
            }).catch(error => { 
                 this.loading=false;
                 this.deleteModalActive=false;
                 this.message="Error. Something went wrong. Could not delete machine account"
            console.log(error)             
            });  
    },

    addUser(){
        this.loading=true;
       this.$axios({
                    method: 'POST',
                    url: this.$store.getters.apiurl + "user",
                    data: {
                        'GID':this.new_GID,
                        'first_name':this.new_first_name,
                        'last_name': this.new_last_name,
                        'navigator_machine_account_name': this.new_navigator_machine_account_name,
                        'is_superuser' : this.new_is_superuser,
                        'is_readonly': this.new_is_readonly,
        
                    },
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': this.$store.getters.oidcIdToken
                    }
                })
                .then((response) => {
                  this.getUsers()
                    console.log(response)
                           this.addNewModal=false;
                          this.new_GID = ''
                          this.new_first_name = '',
                          this.new_last_name = '',
                          this.new_client_id= ''
                          this.new_navigator_machine_account_name= ''
                           this.new_is_superuser= false,
                           this.new_is_readonly = true,
						   this.message = "";
                     this.loading = false;
              

                }).catch((error) => {
                  this.addNewModal=false;
                  this.loading=false;
                  this.message = "Error. Something went wrong. Could not add new user. Please make sure GID is unique."
                    console.log(error);
                    //remove all the stored data if any.

                   
                });
	

    },
  },
  mounted() {
  this.getUsers();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-card, .modal-content {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: auto;
}
.ruledatabasesection{
margin-left:-30px;
margin-right:-30px;
padding-left:-30px;
padding-right:-30px;

}




</style>
